export const spendFileResourcePath = '/me/customer/spend_files';
export const spendFileResourceType = 'spend_file';

export const getSpendFileDownloadResourcePath = (id: string) =>
  `/me/customer/spend_files/${id}/file`;
export const getSpendFileDeleteResourcePath = (id: string) =>
  `/me/customer/spend_files/${id}`;
